const MAX_NAME_LENGTH = 30;

const Validators = {
	MIN_AGE: 18,

	required: value => value !== null && value !== "" && value !== undefined,

	isValidString: string => string !== null && string !== "",

	isValidInput: (input, validator) => (input || (input === 0)) && (input.length !== 0) && (!validator || validator(input)),

	maxNameLength: value => value ? (value.length <= MAX_NAME_LENGTH) : false,

	minNameLength: value => value ? (value.length >= 2) : false,

	maxLastNameLength: value => value ? (value.length <= MAX_NAME_LENGTH) : true,

	minLastNameLength: value => value ? ((value.length === 0) || value.length >= 2) : true,

	exactLength: (value, length) => value ? (value.length === length) : false,

	minNumber: min => value => Number(value) >= min,

	age: (birthYear, minAge) => {

		const today = new Date();

		return (today.getFullYear() - birthYear) >= minAge;
	},

	email: email => {

		let valid = false;
		if (email && email.match) {
			const regex = email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
			valid       = regex !== null;
		}
		return valid;
	},

	hebrewOnly: value => {

		let valid = false;
		if (value || (value === "")) {
			if (value.length) {
				const regex = value.match(/^[\u0590-\u05fe ']+$/i);
				valid       = regex !== null;
			}
			else {
				valid = true;
			}
		}
		return valid;
	},

	phone: phone => {
		if(phone === null) return false
        const israeliNumberRegex = /^(05)([0-9]{1})(\d{7}$)/i
		return israeliNumberRegex.test(phone)
	},

	numbersOnly: (value, allowEmpty) => {

		let returnVal = false;

		if (allowEmpty && !value) {
			returnVal = true;
		}
		else {
			if (value) {
				const strVal = value.toString();

				returnVal = strVal.match(/^[0-9]*$/i);
			}
		}

		return returnVal;
	},

	location: (value, validateOnlyCity = false) => {
		let validated = false;

		const hasCity = !!(value && value.city);

		if (validateOnlyCity === true) {
			validated = hasCity;
		}
		else {
			if (hasCity) {
				if (value.city.hasStreets) {
					validated = value.streetName && value.streetNumber;
				}
				else {
					validated = true;
				}
			}
		}

		return validated;
	}
};

export {Validators};
